import React from 'react';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';

import Tr from '../../../components/common-table/components/Tr';
import Td from '../../../components/common-table/components/Td';
import { ICONS } from '../../../icons';
import CommonIconButton from '../../../components/common-icon-button/CommonIconButton';
import TablePopper from '../../table-popper/TablePopper';
import CommonCheckbox from '../../../components/common-checkbox/CommonCheckbox';
import { enableCustomer } from '../../../redux/customers/customersActions';

import scss from './CustomersTable.module.scss';

const CustomersTableItem = ({ customer = {}, onDelete }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, companyName, city, users, enabled } = customer;

  const handleEditWriter = () => {
    navigate(`${id}`);
  };

  const handleDelete = () => {
    onDelete(customer);
  };

  const handleEnableCustomer = () => {
    dispatch(enableCustomer({ id, enabled }));
  };

  return (
    <Tr>
      <Td isLeft>
        <span className={scss.cellName}>{companyName}</span>
      </Td>
      <Td isLeft>{id}</Td>
      <Td isLeft>{city}</Td>
      <Td extraClasses={scss.cellUsers}>
        <TablePopper content={users} />
      </Td>
      <Td extraClasses={scss.cellEnable}>
        <CommonCheckbox checked={enabled} onChange={handleEnableCustomer} />
      </Td>
      <Td extraClasses={scss.cellAction}>
        <CommonIconButton icon={ICONS.Edit} onClick={handleEditWriter} disabled={!enabled} />

        <CommonIconButton icon={ICONS.Delete} onClick={handleDelete} />
      </Td>
    </Tr>
  );
};

export default CustomersTableItem;
